import { render, staticRenderFns } from "./SelectedCongressDistrict.vue?vue&type=template&id=ed7a0a3c&scoped=true"
import script from "./SelectedCongressDistrict.vue?vue&type=script&lang=js"
export * from "./SelectedCongressDistrict.vue?vue&type=script&lang=js"
import style0 from "./SelectedCongressDistrict.vue?vue&type=style&index=0&id=ed7a0a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7a0a3c",
  null
  
)

export default component.exports